module.exports = __webpack_public_path__ + "media/images/new/icons/arrow_prev-01e8f833c64328cb3a1e8b7ffebbca60.png";